import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from '../../app.settings';

@Component({
	selector: 'blocked-business-modal',
	template: require('./blocked-business-modal.component.html'),
})
export class BlockedBusinessModalComponent {
	@Input() blockedUser: boolean = false;
	@Input() isForgotPasswordClicked: boolean = false;
	public isCorporateBlockedFlowEnabled: boolean = AppSettings.isCorporateBlockedFlowEnabled;
	public isRebrading = AppSettings.isRebrading;

	constructor(private activeModal: NgbActiveModal) {}

	closeModal(): void {
		this.activeModal.close();
	}

	public setTitle(): string {
		if (this.blockedUser || this.isForgotPasswordClicked)
			return this.isCorporateBlockedFlowEnabled
				? 'Ανάκτηση Password από νόμιμο εκπρόσωπο'
				: 'O λογαριασμός σας έχει κλειδωθεί';
		else return 'Ανάκτηση Username/Password χρήστη';
	}

	public setText(): string {
		if (this.blockedUser || this.isForgotPasswordClicked)
			return this.isCorporateBlockedFlowEnabled
				? 'Για να ανακτήσετε τον λογαριασμό σας παρακαλώ επικοινωνήστε με το νόμιμο εκπρόσωπο της επιχείρησής σας'
				: 'Για να τον ξεκλειδώσετε παρακαλώ επικοινωνήστε με το νόμιμο εκπρόσωπο της επιχείρησής σας';
		else
			return 'Για να ανακτήσετε το Username/Password σας παρακαλώ επικοινωνήστε με το νόμιμο εκπρόσωπο της επιχείρησής σας';
	}
}
